module.exports = __webpack_public_path__ + "static/media/sensable_20.74b75ac2.gif";